import React from 'react';

const BackBtn = ( props ) => {

    return (
        <div className="main-wrapper__back-box">
            <button
                className="main-wrapper__back ver-top-box fs14 sprite-b pr"
                type="button"
                onClick={() => props.clickCallBack()}
            >{props.title}</button>
        </div>
    );

};

export default BackBtn;